import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loginSuccess } from '../store/reducers/authReducer';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get('token');
    
    if (token) {
      // Decode token to get user info
      try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split('')
            .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('')
        );
        const user = JSON.parse(jsonPayload);
        
        dispatch(loginSuccess({ user, token }));
        navigate('/dashboard');
      } catch (error) {
        console.error('Failed to decode token:', error);
        navigate('/login');
      }
    } else {
      navigate('/login');
    }
  }, [dispatch, navigate, searchParams]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary to-secondary flex items-center justify-center">
      <div className="bg-white rounded-xl shadow-2xl p-8 max-w-sm w-full mx-4">
        <div className="flex flex-col items-center">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-primary border-t-transparent mb-4"></div>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">Authenticating...</h2>
          <p className="text-gray-600 text-center">Please wait while we sign you in</p>
        </div>
      </div>
    </div>
  );
};

export default AuthCallback;